// extracted by mini-css-extract-plugin
export default {"header":"header_header__TQLgL","header__title":"header_header__title__lDXsF"};